import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyRapidBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-board',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView'],
	__unsafeOrder: -1,
};
